import type { Answer, Quiz } from '@efdigital/ll-addon-data';
import {
  answerDisplayValue,
  onboardingQuestionLayout,
} from '@efdigital/ll-xceed-v2/utils/quiz/quiz-answer-display';
import type { TOC } from '@ember/component/template-only';

interface OnboardingAnswerSummarySignature {
  Args: {
    quiz: Quiz;
    answer: Answer;
  };
}

function gt(left: number, right: number): boolean {
  return left > right;
}

<template>
  {{#let (onboardingQuestionLayout @quiz) as |layout|}}
    <div class="row g-3 mb-4">
      {{#if layout.industry}}
        <div class="col-sm-6 col-lg-4">
          <div class="card border shadow-sm rounded-4 h-100">
            <div class="card-body p-3 p-lg-4">
              <p class="gud-eyebrow text-body-secondary mb-2">Industry</p>
              <p class="fw-bold mb-0">
                {{answerDisplayValue layout.industry @answer}}
              </p>
            </div>
          </div>
        </div>
      {{/if}}

      {{#if layout.seniority}}
        <div class="col-sm-6 col-lg-4">
          <div class="card border shadow-sm rounded-4 h-100">
            <div class="card-body p-3 p-lg-4">
              <p class="gud-eyebrow text-body-secondary mb-2">Seniority</p>
              <p class="fw-bold mb-0">
                {{answerDisplayValue layout.seniority @answer}}
              </p>
            </div>
          </div>
        </div>
      {{/if}}

      {{#if layout.languagePreferences.length}}
        <div class="col-sm-6 col-lg-4">
          <div class="card border shadow-sm rounded-4 h-100">
            <div class="card-body p-3 p-lg-4">
              <p class="gud-eyebrow text-body-secondary mb-2">
                {{if
                  (gt layout.languagePreferences.length 1)
                  "Language preferences"
                  "Language preference"
                }}
              </p>
              {{#each layout.languagePreferences as |question index|}}
                <p class="fw-bold {{if index 'mb-0' 'mb-1'}}">
                  {{answerDisplayValue question @answer}}
                </p>
              {{/each}}
            </div>
          </div>
        </div>
      {{/if}}
    </div>

    {{#each layout.remaining as |question|}}
      <div class="card border shadow-sm rounded-4 mb-3">
        <div class="card-body p-4">
          <p class="fw-bold mb-1">{{question.title}}</p>
          <p class="mb-0">{{answerDisplayValue question @answer}}</p>
        </div>
      </div>
    {{/each}}
  {{/let}}
</template> satisfies TOC<OnboardingAnswerSummarySignature>;
